import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { styled } from '@components-shared/src/stitches';
import { LikeButton } from '@components/Likes/Button';
import { useLikeRelease } from '@components/Likes/useLikeRelease';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleaseCardActionsFragmentDoc } from '@graphql/reactQuery';
import { SongCardDropdown } from './shared/SongCardDropdown';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseCardActions on Release {
    id
    type
    ...SongCardDropdownInfo
  }
`);

export const ReleaseCardActions = ({
  data,
  showGiftOption,
}: {
  data: FragmentType<ReleaseCardActionsFragmentDoc>;
  showGiftOption?: boolean;
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  const release = getFragment(ReleaseCardActionsFragmentDoc, data);

  const { isLiked, onClick: onLikeClick } = useLikeRelease({ id: release.id, source: 'Card' });

  return (
    <ActionItemContainer>
      <div className="[&_path]:transition-colors [&_path]:duration-300 [&_path]:hover:fill-white">
        <SongCardDropdown
          variant="tertiary"
          showLikeSound={false}
          release={release}
          isDropdownOpen={isDropdownOpen}
          setIsDropdownOpen={setIsDropdownOpen}
          showGiftOption={showGiftOption}
        />
      </div>

      <div className="[&_path]:transition-colors [&_path]:duration-300 [&_path]:hover:fill-white">
        {release.type !== 'ALBUM' && (
          <LikeButton onClick={onLikeClick} liked={isLiked} disabled={false} variant="tertiary" />
        )}
      </div>
    </ActionItemContainer>
  );
};

const ActionItemContainer = styled('div', {
  display: 'flex',
  '.liked': {
    visibility: 'visible',
  },
  // We need to offset the icon button is 32px and svg is 20px
  // This is to make sure the content is truly at the end of the container
  marginRight: 20 - 32,
});
